export default "__VITE_ASSET__CdnpPRz9__"